<template>
  <ion-page class="ion-page-white">
    <menu-header>
      <ion-text class="font-bold ion-text-brand block text-center"
        >Testing</ion-text
      >
    </menu-header>
    <ion-content>
      <div class="px-7 pt-6 max-w-xl mx-auto">
        <div v-if="debugging">
          <pre>
              <small> {{ debugging }} </small>
          </pre>
        </div>
        <div>
          <ion-text class="text-lg font-bold ion-text-brand">Device Info</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <span class="block py-1">
              <strong>deviceID:</strong> {{ deviceID }}
            </span>
            <span class="block py-1">
              <strong>deviceName:</strong> {{ deviceName }}
            </span>
            <span class="block py-1">
              <strong>deviceModel:</strong> {{ deviceModel }}
            </span>
            <span class="block py-1">
              <strong>deviceOperatingSystem:</strong> {{ deviceOperatingSystem }}
            </span>
            <span class="block py-1">
              <strong>deviceOrientation:</strong> {{ deviceOrientation }}
            </span>
          </ion-text>
        </div>
        <div>
          <ion-text class="text-lg font-bold ion-text-brand">Live Update Testing</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <span class="block py-1">
              <strong>test code:</strong> 3
            </span>
          </ion-text>
        </div>

        <div class="my-6">
          <ion-text class="text-lg font-bold ion-text-brand">App Info</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <span class="block py-1">
              <strong>currentVersion:</strong> {{ currentVersion }}
            </span>
            <span class="block py-1">
              <strong>installedVersion:</strong> {{ installedVersion }}
            </span>
            <span class="block py-1">
              <strong>availableVersion:</strong> {{ availableVersion }}
            </span>
            <span class="block py-1">
              <strong>minimumSupportedVersion:</strong> {{ minimumSupportedVersion }}
            </span>
          </ion-text>
        </div>

        <div class="my-6">
          <ion-text class="text-lg font-bold ion-text-brand">Browser</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <button @click="openBrowser('https://www.jacarandafinance.com.au/')">
              <span class="ion-text-primary underline">Open Browser Test</span>
            </button>
          </ion-text>
        </div>

        <div class="my-6">
          <ion-text class="text-lg font-bold ion-text-brand">Keyboard</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <span class="block py-1">
              <strong>keyboardStyle:</strong> {{ KeyboardStyle.Light }}
            </span>
            <span class="block py-1">
              <strong>keyboardResize:</strong> {{ KeyboardResize.Body }}
            </span>
          </ion-text>
        </div>

        <div class="my-6">
          <ion-text class="text-lg font-bold ion-text-brand">Status Bar</ion-text>
          <ion-text class="text-sm ion-text-brand mt-3 mb-6 block">
            <button class="block my-1" @click="hideStatusBar">
              <span class="ion-text-primary underline">Test: Hide Status Bar</span>
            </button>
            <button class="block my-1" @click="showStatusBar">
              <span class="ion-text-primary underline">Test: Show Status Bar</span>
            </button>
          </ion-text>
        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { onUnmounted } from "vue";
import { useConfigStore, useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { useBrowser } from '@/composables/browser';
import { useStatusBar } from "@/composables/statusBar";
import { KeyboardResize, KeyboardStyle } from '@capacitor/keyboard';
import MenuHeader from "@/components/menu/MenuHeader.vue";
const configStore = useConfigStore();
const customerStore = useCustomerStore();
const { debugging, minimumSupportedVersion } = storeToRefs(configStore);
const { deviceID, deviceName, deviceModel, deviceOperatingSystem, currentVersion, installedVersion, availableVersion, deviceOrientation } = storeToRefs(customerStore);
const { openBrowser } = useBrowser();
const { hideStatusBar, showStatusBar } = useStatusBar();
onUnmounted(() => {
  showStatusBar();
})
</script>
